const SHOW_OTP_MODAL = "SHOW_OTP_MODAL";
const HIDE_OTP_MODAL = "HIDE_OTP_MODAL";

const OTP_MODAL_TYPES = {
  SHOW_OTP_MODAL,
  HIDE_OTP_MODAL,
};

export default OTP_MODAL_TYPES;
